module.exports = __webpack_public_path__ + "img/home.2aff05fe.svg";